<template>
  <div class="main-wrapper">
    <main class="main-content" role="main">
      <article class="header-img">
        <h1 class="impressum">Impressum</h1>
      </article>
      <table>
        <tr>
          <td class="left">Firmenname:</td>
          <td>Eisart Oliver Laudam</td>
        </tr>

      <tr>
          <td class="left">Anschrift:</td>
          <td>
            Kiebitzweg 41 <br>
            22869 Schenefeld
          </td>
      </tr>

      <tr>
          <td class="left">Telefon:</td>
          <td>+49 (0)40 84051812</td>
      </tr>

      <tr>
          <td class="left">USt.Id:</td>
          <td>DE 3104901573</td>
      </tr>

      <tr>
          <td class="left">Geschäftsführer:</td>
          <td>Oliver Laudam</td>
      </tr>

      </table>
    </main>
  </div>
</template>

<script>
export default {
  name: "ImpressumView",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
@import "https://fonts.googleapis.com/css?family=Raleway:500|Roboto:300";
@import "../../assets/css/normalize.css";
@import "../../assets/css/atmosphere.css";
@import "../../assets/css/layout.css";

table {
  display: table;
}
.left {
  width: 20vh;
  font-weight: bold;
}

.header-img {
  background: url("../../assets/img/aaron-burden-CKlHKtCJZKk-unsplash.jpg")
    no-repeat;
  background-size: cover;
  padding: 0.5em 4em 5em 4em;
}

.impressum {
  text-align: right;
  font-size: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/eisart/impressum.vue